
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/takedown-policy",
      function () {
        return require("private-next-pages/takedown-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/takedown-policy"])
      });
    }
  